/// <reference path="../defs/common.d.ts" />

import type { ProductsFilterParamsObj } from '~/types';
import { BaseModel } from '~/models/base-model';

export class ProductsQueryParamsModel extends BaseModel<ProductsFilterParamsObj> {
    market: Nullable<string> = null;
    category: Nullable<string> = null;
    f: Nullable<string[]> = null;
    expand?: Nullable<string[]> = null;
    search?: Nullable<string> = null;
    ordering?: Nullable<string> = 'sort_order';
    filter?: Nullable<string> = null;
    fields?: Nullable<string> = null;
    omit?: Nullable<string> = null;
}
